<svg
  width="14"
  height="14"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M5.40137 0C8.38425 0.000109942 10.8027 2.41765 10.8027 5.40039C10.8027 6.67654 10.3583 7.8482 9.61816 8.77246L11.8223 10.9766L11.8643 11.0225C12.0564 11.2582 12.042 11.6055 11.8223 11.8252C11.6026 12.0447 11.2552 12.0593 11.0195 11.8672L10.9736 11.8252L8.76953 9.62109C7.84592 10.3591 6.67555 10.8017 5.40137 10.8018C2.41839 10.8018 0 8.38321 0 5.40039C1.382e-05 2.41758 2.4184 0 5.40137 0ZM5.40137 1.2002C3.08128 1.2002 1.20021 3.08043 1.2002 5.40039C1.2002 7.72036 3.08127 9.60156 5.40137 9.60156C6.53253 9.60151 7.55825 9.15288 8.31348 8.42578C8.32911 8.40552 8.3447 8.38479 8.36328 8.36621C8.38184 8.34765 8.40261 8.33203 8.42285 8.31641C9.15226 7.56081 9.60254 6.53352 9.60254 5.40039C9.60253 3.0805 7.72136 1.20031 5.40137 1.2002Z"
    style="fill: #717680 !important;"
  />
</svg>
